import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import { AppProvider } from "./components/AppContext";

const App: React.FC = () => {
  return (
    <Router>
      <AppProvider>
        <Dashboard />
      </AppProvider>
    </Router>
  );
};

export default App;
